/**
 * FAQs — COREEX
 * - Clicking a category pill filters which question rows are visible
 *   (matched via a lowercased/trimmed data-category attribute set in
 *   Liquid), no page reload.
 * - Clicking a question intercepts the native <details>/<summary>
 *   toggle and animates the answer wrapper's height with WAAPI, using
 *   one shared duration for both opening and closing.
 * - Optional "single open" mode closes any other open (visible)
 *   question first.
 */
(function () {
  var ROOT_SELECTOR = '[data-coreex-faqs]';

  document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
    initCategoryFilter(root);
    initAccordion(root);
  });

  function initCategoryFilter(root) {
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.coreex-faqs__nav-item'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.coreex-faqs__item'));

    if (navItems.length === 0) return;

    navItems.forEach(function (nav) {
      nav.addEventListener('click', function () {
        var category = nav.dataset.category;

        navItems.forEach(function (other) {
          var isActive = other === nav;
          other.classList.toggle('coreex-faqs__nav-item--active', isActive);
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        items.forEach(function (item) {
          if (item.dataset.category === category) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function initAccordion(root) {
    var singleOpen = root.dataset.singleOpen === 'true';
    var speedSeconds = parseFloat(root.dataset.panelSpeed) || 0.3;
    var duration = speedSeconds * 1000;
    var items = Array.prototype.slice.call(root.querySelectorAll('.coreex-faqs__item'));

    items.forEach(function (item) {
      var summary = item.querySelector('.coreex-faqs__summary');
      var wrapper = item.querySelector('.coreex-faqs__answer-wrapper');
      if (!summary || !wrapper) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();

        var isOpen = item.hasAttribute('open');

        if (isOpen) {
          animateClose(item, wrapper, duration);
          return;
        }

        if (singleOpen) {
          items.forEach(function (other) {
            if (other !== item && other.hasAttribute('open') && !other.hasAttribute('hidden')) {
              var otherWrapper = other.querySelector('.coreex-faqs__answer-wrapper');
              if (otherWrapper) animateClose(other, otherWrapper, duration);
            }
          });
        }

        animateOpen(item, wrapper, duration);
      });
    });
  }

  function animateOpen(item, wrapper, duration) {
    var fullH = wrapper.scrollHeight;

    item.setAttribute('open', '');

    var animation = wrapper.animate(
      [{ height: '0px' }, { height: fullH + 'px' }],
      { duration: duration, easing: 'ease', fill: 'forwards' }
    );

    animation.onfinish = function () {
      wrapper.style.height = 'auto';
    };
  }

  function animateClose(item, wrapper, duration) {
    var currentH = wrapper.getBoundingClientRect().height;

    wrapper.style.height = currentH + 'px';
    // Force reflow so the browser registers the explicit height above
    // before the animation starts from it.
    // eslint-disable-next-line no-unused-expressions
    wrapper.getBoundingClientRect();

    var animation = wrapper.animate(
      [{ height: currentH + 'px' }, { height: '0px' }],
      { duration: duration, easing: 'ease', fill: 'forwards' }
    );

    animation.onfinish = function () {
      item.removeAttribute('open');
      wrapper.style.height = '';
    };
  }
})();
